import $ from "jquery";
import CONFIG from "@bd-core/config";
import compile from "@bd-utils/handlerbars-helper";
import { getState } from "@bd-stores/store";

export default class PlayersStatus {
    init() {
        // Don't run this on static page
        if (!CONFIG.game.cfgLimit) return false;
        const self = this;
        $(document).on("bd__playersStateChanged", () => self.render());
    }

    render() {
        if ($("#playersStatus-item").length < 1) return;
        const players = getState().gameProgress.players;
        const leaderID = getState().gameProgress.leader;
        const template = $("#playersStatus-item").html();

        /**
         * All online players
         */
        const onlinePlayers = players.filter((p) => p.isOnline);

        /**
         * Set current user and leader flag
         */
        const enhancedPlayers = onlinePlayers.map((p) => ({
            ...p,
            isCurrentUser: p.userId === CONFIG.user.id,
            isLeader: p.userId === leaderID,
        }));

        $(".playersStatus-list").each(function () {
            const location = getState().userProgress.currentPageId;

            const roommate = enhancedPlayers.filter(
                (p) => p.currentPageId == location,
            );

            roommate.sort((a, b) => {
                if (a.isCurrentUser) return -1;
                if (b.isCurrentUser) return 1;
                return 0;
            });

            const html = compile(template, { players: roommate });
            $(this).html(html);
        });
    }
}
